import { createFileRoute } from "@tanstack/react-router";
import AdminSurveyTopicPage from "@/pages/admin/surveys/detail/topics/detail";
import { useSurveysPermissions } from "@/pages/admin/surveys";

export const Route = createFileRoute("/app/admin/surveys/$surveyId/topics/$topicId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { surveyId, topicId } = Route.useParams();
  const { userCanEditAllSurveys, userCanViewAllSurveys } = useSurveysPermissions();

  return (
    <AdminSurveyTopicPage
      surveyId={surveyId}
      topicId={topicId}
      userCanEditAllSurveys={userCanEditAllSurveys}
      userCanViewAllSurveys={userCanViewAllSurveys}
    />
  );
}
